import { useState } from 'react';
// form
import { useFormContext, Controller } from "react-hook-form";
// @mui
import { TextField, Autocomplete, Box, Chip, Stack } from '@mui/material';

export default function RHFCategorySelect({ name, label, placeholder, options, position, onChange: ignored, helperText, ...other }) {
  const [open, setOpen] = useState(false);
  const openPopper = () => setOpen(true);
  const closePopper = () => setOpen(false);
  const { control } = useFormContext();
  
  return (
    <Controller
      name={name}
      control={control}
      render={(props) => (
        <Autocomplete
          multiple
          open={open}
          onOpen={openPopper}
          onClose={closePopper}
          onChange={(_, values) => {
            if(values.length > 3) closePopper();
            else props.field.onChange(values);
            if(values.length === 3) closePopper();
          }}
          options={options}
          value={props.field.value}
          getOptionLabel={(option) => `${option.name}`}
          isOptionEqualToValue={(option, value) => option.name === value.name}
          groupBy={(option) => option.group || ''}
          disableCloseOnSelect
          renderGroup={(params) => (
            <Stack key={params.group}>
              <Box sx={{ mx: { xs: 1, sm: 2}, my: 2, maxWidth: '100%', display: 'flex', flexWrap: 'wrap' }}>
                {params.children}
              </Box>
            </Stack>
          )}
          renderOption={(props, option, state) => (
            <Chip
              {...props}
              label={option.name}
              variant="outlined"
              />
          )}
          renderInput={(params) => (
            <TextField 
              {...params}
              fullWidth
              label={label}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
                autoComplete: 'new-password', // disable autocomplete and autofill
              }}
              placeholder={placeholder}
              error={!!props.fieldState.error}
              helperText={props.fieldState.error?.message ? props.fieldState.error.message : helperText}
            />
          )}
          {...other}
        />
      )}
    />
  );
}
